import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 發送簡訊驗證碼
 */
const SendSmsOtp = [
    'POST',
    RouteUrlList.API_SendSmsOtp.path,
    {},
    200,
    {
        status: true,
        title: '資料載入成功',
        message: '取得成功',
        errorCode: '',
        code: 0,
        letter: 'ABC',
        isInWaitToSendAgain: false,
        dayLimit: 10,
        times: 1
    }
];
export default SendSmsOtp;
